(function () {
  "use strict";

  var HEAD_RE = /dentist[‑–—-]?quality fit/i;
  var TAIL_RE = /^enjoy the comfort of a dentist/i;
  var CLOSE_SEL = 'button, [class*="close"], [id*="close"], [data-dismiss], [aria-label*="close" i], svg, img';
  var IMG_SRC = "https://cdn.shopify.com/s/files/1/0024/6346/5541/files/02_dial_in_your_own_setting.png?v=1785927844";
  var IMG_W = 520;
  var IMG_H = 380;
  var POP_SEL = '[role="dialog"], [aria-modal="true"], .modal, .popup, [class*="popup"], [class*="modal"]';
  var CART_SEL = '#slidecarthq, [id*="slidecart" i], [class*="slidecart" i], [class*="slide-cart" i]';
  var TRIGGER_RE = /^why it.?s effective$/i;
  var TRIGGER_LABEL = "What fitting it is actually like";
  var TRIGGER_META = "30 sec read";

  function txt(el) {
    return (el.textContent || "").replace(/\s+/g, " ").trim();
  }

  function findHeading(root) {
    var nodes = root.querySelectorAll("h1,h2,h3,h4,h5,h6,p,div,span,strong,b");
    var best = null;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = txt(el);
      if (!t || t.length > 90) continue;
      if (!HEAD_RE.test(t)) continue;
      if (!best || best.contains(el)) best = el;
    }
    return best;
  }

  function findTail(root) {
    var nodes = root.querySelectorAll("p,div,span,em,i");
    var best = null;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = txt(el);
      if (!t || t.length > 200) continue;
      if (!TAIL_RE.test(t)) continue;
      if (!best || best.contains(el)) best = el;
    }
    return best;
  }

  function promote(el) {
    var t = txt(el);
    var n = el;
    while (n.parentElement && n.parentElement !== document.body && txt(n.parentElement) === t) {
      n = n.parentElement;
    }
    return n;
  }

  function isProtected(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches(CLOSE_SEL)) return true;
    if (node.querySelector && node.querySelector(CLOSE_SEL)) return true;
    return false;
  }

  function dialogOf(el) {
    var n = el;
    for (var i = 0; i < 8 && n; i++) {
      if (n.id === "popup") return n;
      if (n.matches && n.matches('[role="dialog"], [aria-modal="true"], .modal, .popup, [class*="popup"]')) return n;
      n = n.parentElement;
    }
    return null;
  }

  function buyAnchor() {
    var f = document.querySelector('form[action*="/cart/add"]');
    if (f) return f;
    var b = document.querySelector("#btnCTA");
    if (b) return b;
    var all = document.querySelectorAll("button, a, input[type=submit]");
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var t = (el.value || el.textContent || "").trim();
      if (/add\s+.*\bto\s+cart\b/i.test(t) && el.offsetParent !== null) return el;
    }
    return document.querySelector("h1");
  }

  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function isCartUi(el) {
    return !!(el && ((el.matches && el.matches(CART_SEL)) || (el.closest && el.closest(CART_SEL))));
  }

  function outermost(dlg) {
    var n = dlg;
    while (
      n.parentElement &&
      n.parentElement !== document.body &&
      n.parentElement.matches &&
      n.parentElement.matches(POP_SEL)
    ) {
      n = n.parentElement;
    }
    return n;
  }

  function hardHide(el) {
    if (!el || isCartUi(el)) return;
    el.setAttribute("data-vs-forced", "1");
    if (el.tagName === "DIALOG" && typeof el.close === "function") {
      try {
        el.close();
      } catch (err) {}
    }
    el.removeAttribute("open");
    el.style.setProperty("display", "none", "important");
  }

  function unlockScroll() {
    var cart = document.querySelector(CART_SEL);
    if (cart && visible(cart)) return;
    var els = [document.body, document.documentElement];
    for (var i = 0; i < els.length; i++) {
      if (els[i] && els[i].style && els[i].style.overflow === "hidden") els[i].style.overflow = "";
    }
  }

  function closeDialog(dlg, done) {
    done = done || function () {};
    if (!dlg) {
      done();
      return;
    }
    if (dlg.tagName === "DIALOG" && typeof dlg.close === "function") {
      try {
        dlg.close();
      } catch (err) {}
    }
    var btn = dlg.querySelector('[class*="close"], [id*="close"], [aria-label*="close" i], [data-dismiss]');
    if (btn && typeof btn.click === "function") btn.click();
    if (dlg.id && location.hash === "#" + dlg.id) location.hash = "vs-fit-off";

    setTimeout(function () {
      var root = outermost(dlg);
      if (visible(root)) hardHide(root);
      unlockScroll();
      done();
    }, 220);
  }

  function srcset(img) {
    var src = img.getAttribute("src") || "";
    if (src.indexOf("cdn.shopify.com") === -1) return;
    var native = parseInt(img.getAttribute("width") || "0", 10);
    if (!native) return;
    var join = src.indexOf("?") === -1 ? "?" : "&";
    var cands = [420, 640, 960, 1280].filter(function (w) {
      return w < native;
    });
    cands.push(native);
    var parts = cands.map(function (w) {
      return src + join + "width=" + w + " " + w + "w";
    });
    img.setAttribute("srcset", parts.join(", "));
    img.setAttribute("sizes", "(max-width: 640px) 100vw, 560px");
    img.style.maxWidth = native + "px";
    img.style.aspectRatio = native + " / " + (parseInt(img.getAttribute("height") || "0", 10) || native);
  }

  function build() {
    var wrap = document.createElement("div");
    wrap.className = "vs-fit";
    wrap.setAttribute("data-vs-fit", "content");

    var html = "";
    html += '<p class="vs-fit__eyebrow">The fit</p>';
    html += '<p class="vs-fit__h">Molded to your bite in about five minutes</p>';
    html += "<p>Soften it in hot water, bite down, let it cool. It sets to the shape of your own teeth at your kitchen sink. No appointment, no impression kit in the mail, no waiting two weeks for it to come back.</p>";
    html += '<div class="vs-fit__box">';
    html += '<p class="vs-fit__box-h">Fit not right? We will make it right.</p>';
    html += "<p>If it does not fit well, we send you a free replacement or a free size exchange. Every VitalSleep also comes with a one-year unlimited warranty.</p>";
    html += "</div>";
    html += '<p class="vs-fit__sub">What the first few nights feel like</p>';
    html += "<p>You will notice it for the first two or three nights. Some people wake up with a little jaw or gum soreness early on, and it usually settles within a week. Advance the jaw a small turn at a time instead of all at once and it settles faster.</p>";
    html += '<figure class="vs-fit__fig">';
    html += '<img src="' + IMG_SRC + '" alt="VitalSleep mouthpiece held in one hand with the adjustment key" width="' + IMG_W + '" height="' + IMG_H + '" loading="lazy" decoding="async">';
    html += "<figcaption>Advance the jaw a little at a time with the included key.</figcaption>";
    html += "</figure>";
    html += '<div class="vs-fit__foot">';
    html += '<button type="button" class="vs-fit__cta">Choose your size</button>';
    html += '<p class="vs-fit__note">60 nights to try it &middot; Free size exchanges</p>';
    html += "</div>";

    wrap.innerHTML = html;

    var img = wrap.querySelector("img");
    if (img) {
      srcset(img);
      img.addEventListener("error", function () {
        var fig = img.closest(".vs-fit__fig");
        if (fig) fig.setAttribute("data-vs-empty", "1");
      });
    }
    return wrap;
  }

  function wire(wrap, dlg) {
    var cta = wrap.querySelector(".vs-fit__cta");
    if (!cta) return;
    cta.addEventListener("click", function (e) {
      e.preventDefault();
      closeDialog(dlg, function () {
        var target = buyAnchor();
        if (!target) return;
        var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        try {
          target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
        } catch (err) {
          target.scrollIntoView();
        }
      });
    });
  }

  function styleTrigger() {
    var nodes = document.querySelectorAll('a, button, [role="button"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute("data-vs-fitlink")) continue;
      if (el.closest && el.closest(POP_SEL)) continue;
      var t = txt(el);
      if (!TRIGGER_RE.test(t)) continue;
      if (!visible(el)) continue;

      var node = el;
      var kids = el.querySelectorAll("*");
      for (var k = 0; k < kids.length; k++) {
        if (txt(kids[k]) === t && kids[k].children.length === 0) node = kids[k];
      }
      if (node === el) {
        el.textContent = "";
        var lab = document.createElement("span");
        lab.className = "vs-fitlink__t";
        lab.textContent = TRIGGER_LABEL;
        el.appendChild(lab);
      } else {
        node.textContent = TRIGGER_LABEL;
        if (node.classList) node.classList.add("vs-fitlink__t");
      }

      var ico = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      ico.setAttribute("class", "vs-fitlink__ico");
      ico.setAttribute("viewBox", "0 0 20 20");
      ico.setAttribute("fill", "none");
      ico.setAttribute("aria-hidden", "true");
      ico.innerHTML =
        '<circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.5"></circle>' +
        '<path d="M10 6.4v7.2M6.4 10h7.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>';
      el.insertBefore(ico, el.firstChild);

      var meta = document.createElement("span");
      meta.className = "vs-fitlink__meta";
      meta.textContent = TRIGGER_META;
      el.appendChild(meta);

      el.setAttribute("data-vs-fitlink", "1");
      el.classList.add("vs-fitlink");
      return true;
    }
    return false;
  }

  function apply() {
    var heading = findHeading(document);
    if (!heading) return false;
    heading = promote(heading);

    var parent = heading.parentElement;
    if (!parent) return false;
    if (parent.getAttribute("data-vs-fit-done") === "1" && parent.querySelector('[data-vs-fit="content"]')) return true;

    var dlg = dialogOf(heading);
    var tail = findTail(dlg || parent);

    var kids = Array.prototype.slice.call(parent.childNodes);
    var start = kids.indexOf(heading);
    if (start === -1) return false;

    var end = kids.length - 1;
    if (tail) {
      var t = tail;
      while (t && t.parentElement !== parent) t = t.parentElement;
      if (t) {
        var ti = kids.indexOf(t);
        if (ti >= start) end = ti;
      }
    }

    var doomed = [];
    for (var i = start; i <= end; i++) {
      var n = kids[i];
      if (!n) continue;
      if (isProtected(n)) continue;
      doomed.push(n);
    }
    if (!doomed.length) return false;

    var wrap = build();
    parent.insertBefore(wrap, heading);
    for (var j = 0; j < doomed.length; j++) {
      if (doomed[j].parentNode === parent) parent.removeChild(doomed[j]);
    }
    wire(wrap, dlg);
    parent.setAttribute("data-vs-fit-done", "1");

    if (dlg && !dlg.getAttribute("data-vs-fit-esc")) {
      dlg.setAttribute("data-vs-fit-esc", "1");
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        if (!dlg.querySelector('[data-vs-fit="content"]')) return;
        if (dlg.offsetParent === null && location.hash !== "#popup") return;
        closeDialog(dlg);
      });
    }
    return true;
  }


  /* 16-Sep-2026 speed fix: the page-wide watcher used to run forever. Any change
     anywhere on the page (the 1-second shipping countdown, carousels, the cart)
     re-ran the text search below. Now it watches for WATCH_MS after load and
     stops as soon as the job is done. A click or a resize re-checks for a few
     seconds, which covers popups and tabs that build their content late. */
  var WATCH_MS = 15000;
  var REARM_MS = 3000;
  function leash(check) {
    var obs = null, stopT = null, queued = false;
    function stop() {
      if (obs) { obs.disconnect(); obs = null; }
      if (stopT) { clearTimeout(stopT); stopT = null; }
    }
    function run() {
      queued = false;
      if (check()) stop();
    }
    function arm(ms) {
      if (!window.MutationObserver) return;
      if (!obs) {
        obs = new MutationObserver(function () {
          if (queued) return;
          queued = true;
          setTimeout(run, 250);
        });
        obs.observe(document.documentElement, { childList: true, subtree: true });
      }
      if (stopT) clearTimeout(stopT);
      stopT = setTimeout(stop, ms);
    }
    var pokeT = null;
    function poke() {
      if (pokeT) return;
      pokeT = setTimeout(function () {
        pokeT = null;
        if (!check()) arm(REARM_MS);
      }, 350);
    }
    if (!check()) arm(WATCH_MS);
    document.addEventListener("click", poke, true);
    window.addEventListener("resize", poke, { passive: true });
  }

  function start() {
    styleTrigger();
    apply();
    leash(function () {
      if (!document.querySelector("[data-vs-fitlink]")) styleTrigger();
      if (!document.querySelector('[data-vs-fit="content"]')) apply();
      return !!(document.querySelector("[data-vs-fitlink]") && document.querySelector('[data-vs-fit="content"]'));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
